export const CONTAINER_ID = 'radioButton-container';
export const RADIO_ID = 'radioButton-radio';
export const LABEL_ID = 'radioButton-label';
